/**
 * Dashboard "continue your checkout" card config.
 *
 * Context: three people started a checkout on 2026-10-14 and none paid. Lemon.js
 * documents `Checkout.Success` but no checkout-close event, so the only signal
 * that someone walked away is a saved attempt plus a later dashboard visit.
 * See apps/client/src/pages/dashboard/_components/checkout-resume-card.tsx.
 */

/**
 * An attempt younger than this is not offered back. The buyer may still be
 * typing a card into the overlay, or the Lemon Squeezy webhook may not have
 * landed yet; prompting them mid-payment is noise at best and a double charge
 * at worst. Lowering it risks nagging people who are still paying; raising it
 * delays the prompt for those who really left.
 */
export const CHECKOUT_RESUME_MIN_AGE_MS = 5 * 60 * 1000;

/**
 * An attempt older than this is stale intent and is never offered back. Raising
 * it reaches buyers who return after a weekend at the cost of prompting for a
 * plan they may have stopped wanting; the saved plan is only ever a suggestion,
 * the price shown comes from the live PLANS map.
 */
export const CHECKOUT_RESUME_MAX_AGE_MS = 48 * 60 * 60 * 1000;
